module.exports = __webpack_public_path__ + "img/1.da8d1868.png";